import { translate } from "app/filters/i18nFilter";

import { MetricsRow, MetricTitle } from "../StyledComponent";

import { TopOrganicKeywords } from "./TopOrganicKeywords";
import { TopOrganicPages } from "./TopOrganicPages";

export const TrafficTrends = () => {
    return (
        <MetricsRow
            gap={"16px"}
            marginBottom="32px"
        >
            <MetricTitle>{translate("wa.traffic.sources.search.seo.overview.traffic.trends.title")}</MetricTitle>
            <MetricsRow
                direction="row"
                marginBottom="0"
            >
                <TopOrganicKeywords />
                <TopOrganicPages />
            </MetricsRow>
        </MetricsRow>
    );
};
